module.exports = __webpack_public_path__ + "static/media/fountains_simple_numeration.f995398d.png";